export default __webpack_public_path__ + "static/media/creativityFestival4.3add34a5.png";